import './index.css';
import { View } from '../../../component';
import useTheme from '../../../utilities/hooks/theme';
import React from 'react';
import Button from '@mui/material/Button/Button';
import { isSmartPhone } from '../../../utilities/helper';

interface Props {
  onPressTeamPreview?: any;
  onPressContinue?: any;
  isHideTeamPreview?: boolean;
}

const CreateTeamBottomContainer = ({
  onPressTeamPreview,
  onPressContinue,
  isHideTeamPreview
}: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const continueButton = {
    color: isSmartPhone ? '#fff' : theme.createTeamContinueBtnLabel,
    backgroundColor: isSmartPhone ? '#fff' : theme.createTeamContinueBtn,
    shadowColor: isSmartPhone ? '#00AC02' : theme.createTeamContinueBtn
  };
  const previewButton = {
    color: isSmartPhone ? '#282B31' : '#ffc400',
    backgroundColor: isSmartPhone ? '#FED643' : '#011545',
    shadowColor: isSmartPhone ? '#FED643' : '',
    border: isSmartPhone ? '' : '1px solid #ffc400'
  };
  return (
    <View
      className={
        isSmartPhone ? 'create-team-bottom-container_mWeb' : 'create-team-bottom-container '
      }>
      {isHideTeamPreview && (
        <Button
          onClick={onPressTeamPreview}
          style={previewButton}
          className={
            isSmartPhone ? 'create-team-preview-bottom-button_mWeb' : 'create-team-bottom-button'
          }>
          {'Preview'}
        </Button>
      )}
      <Button
        onClick={onPressContinue}
        style={continueButton}
        className={
          isSmartPhone ? 'create-team-continue-bottom-button_mWeb' : 'create-team-bottom-button'
        }>
        {'Continue'}
      </Button>
    </View>
  );
};
CreateTeamBottomContainer.defaultProps = {
  isHideTeamPreview: true
};
export default React.memo(CreateTeamBottomContainer);
